import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
// import debug from 'debug';
import { Popup, Icon } from 'semantic-ui-react';
import { goPlayer } from '../../../views/Player/module/player';
import {
  toggleSelectedPlayer,
} from '../../../../store/reducers/tableControls';
import classes from './PlayerCell.css';
import { PlayerPT } from './PlayerCell.proptypes';
import { viewTeam, viewTeamSubview } from '../../../views/Team/module/team';
import rookieIcon from '../../../../assets/images/icon-rookie.png';


// const log = debug('huddle:app:components:playerCell');

const mapStateToProps = () => ({
});
const actions = {
  toggleSelectedPlayer,
};
export class PlayerCell extends PureComponent {
  static propTypes = {
    track: PT.bool,
    compare: PT.bool,
    injury: PT.bool,
    player: PlayerPT.isRequired,
    rank: PT.number,
    checked: PT.bool,
    toggleSelectedPlayer: PT.func.isRequired,
    addFixedElement: PT.func.isRequired,
    showHeadshot: PT.bool,
    showLinks: PT.bool,
    showRookie: PT.bool,
  }

  static defaultProps = {
    track: false,
    compare: false,
    injury: false,
    checked: false,
    showHeadshot: false,
    showLinks: true,
    showRookie: false,
  }

  handleChangeSelection = () => {
    this.props.toggleSelectedPlayer(this.props.player);
  }

  handleImageErrored = (e) => {
    e.target.src = "data:image/png;base64,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";
  }

  render = () => {
    const { track, compare, player, rank, injury, checked, showHeadshot, noName, noRank, showLinks, showRookie } = this.props;
    var mobilePlayerCss = {
      minWidth: '150px' // if have checkboxes: 170px
    }
    return (
      <span ref={this.props.addFixedElement} className={classes.playerContainer} style={mobilePlayerCss}>
        <div className={noName && noRank ? classes.hidePlayerDiv : classes.selectPlayerDiv}>
          <div className={classes.boxnumContainer}>{(track || compare) &&
            <input
              type="checkbox"
              value={player.player_id}
              checked={checked}
              onChange={this.handleChangeSelection}
              className={classes.playerCheckbox}
            />}
            {noRank ? <span className={'playerRank'}>&nbsp;</span>
              : <span className={'playerRank'}>{(`${rank}. `)}</span>}
          </div>
          {showLinks === false ? <span className={classes.playerName}>{player.fname} {player.lname}</span> :
            player.player_id ?
              <div className={classes.playerNameContainer}>
                <Link
                  to={goPlayer(player.player_id, `${player.fname}-${player.lname}`)}
                  className={classes.playerName}
                >
                  {
                    (player.position && player.position === 'DF') ? (player.lname || player.fname) :
                      (((injury || player.rookie === 'Y') && player.player.length > 15 || (!injury || player.rookie === 'N') && player.player.length > 17) ?
                        player.fname[0] + '. ' + player.lname : player.player)
                  }

                </Link>
                { showRookie && player.rookie === 'Y' ? <img src={rookieIcon} alt="Rookie Icon" className={classes.rookieIcon} /> : '' }
              </div>
              : <Link to={viewTeam({ id: player.team_id })} className={classes.playerName}>
                {player.player}</Link>
          }
          {
            injury && !!player.injured &&
            <Popup
              trigger={<Icon name="plus" fitted className={classes.cross} />}
              position="top center"
              on="hover"
              wide
              className={classes.injuryPopup}
            >
              <Popup.Header className={classes.popupHeader}>
                <Icon name="plus" fitted className={classes.whiteCross} />
                <span className={classes.popupHeaderText}>{player.player} INJURY ANALYSIS</span>
              </Popup.Header>
              <Popup.Content>
                <b>Type: </b>{player.injury || 'No description available.'}
              </Popup.Content>
            </Popup>
          }
        </div>
        {showHeadshot && player.risk == "Y" &&
          <div className={classes.flagsContainer}>
            <div className={classes.playerFlags}>
              <span className={classes.risk}>Risk</span>
            </div>
          </div>
        }
        {showHeadshot && player.upside == "Y" &&
          <div className={classes.flagsContainer}>
            <div className={classes.playerFlags}>
              <span className={classes.upside}>Upside</span>
            </div>
          </div>
        }

        {showHeadshot && <div className={noRank && noName ? classes.headshotContainerClear : classes.headshotContainer}>
          <div className={noRank && noName ? classes.playerHeadshotClear : classes.playerHeadshot}>
            <img src={player.headshot} alt={player.player} onError={this.handleImageErrored} />
          </div>
        </div>}


      </span>
    );
  }
}
export default connect(mapStateToProps, actions)(PlayerCell);



// WEBPACK FOOTER //
// ./src/app/components/DataTable/PlayerCell/PlayerCell.js